import { createBrowserHistory } from "history";
import { applyMiddleware, compose, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import createSagaMiddleware from "redux-saga";
import { addLocaleData } from "react-intl";
import { getParam } from "url-params-helper";
import esLocaleData from "react-intl/locale-data/es";
import locales from "../locales";
import createRootReducer from "./reducers";
import sagas from "./sagas";

addLocaleData([...esLocaleData]);

export const history = createBrowserHistory({});

const getLocale = () => locales[getParam("lang") || "es"];

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  createRootReducer(history),
  { intl: getLocale() },
  composeEnhancers(applyMiddleware(sagaMiddleware, routerMiddleware(history)))
);

sagaMiddleware.run(sagas);

export default store;
